module.exports = __webpack_public_path__ + "img/star_on.dd33eb04.svg";